var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_99_30891)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9998 7.56152V16.4037C20.9893 16.4606 20.9794 16.5176 20.9675 16.5742C20.9007 16.8938 20.8638 17.2232 20.7615 17.5308C20.0689 19.6177 18.2408 20.9539 16.0516 20.9624C13.3625 20.9729 10.673 20.9663 7.98393 20.9641C7.13245 20.9634 6.31999 20.7771 5.58487 20.3464C3.9146 19.3684 3.05116 17.8989 3.03921 15.9625C3.02233 13.3085 3.03182 10.6542 3.03921 7.99992C3.04026 7.6684 3.05889 7.32914 3.13061 7.00746C3.57815 4.99477 4.803 3.70453 6.78968 3.14836C7.05194 3.07488 7.32722 3.04816 7.59616 3C10.5437 3 13.4908 3 16.4383 3C16.6218 3.02953 16.8075 3.04887 16.9882 3.08965C19.0026 3.54492 20.2946 4.7666 20.8518 6.75574C20.9253 7.01766 20.9517 7.29258 20.9998 7.56152ZM16.941 11.9789C16.9344 9.26309 14.741 7.06863 12.0227 7.05844C9.3146 7.04824 7.08675 9.27504 7.09343 11.9856C7.10011 14.7014 9.2935 16.8959 12.0118 16.9061C14.7199 16.9163 16.9477 14.6895 16.941 11.9789ZM17.2364 5.26758C16.4179 5.27109 15.7369 5.95242 15.7419 6.76313C15.7468 7.57699 16.4323 8.26008 17.242 8.25762C18.0573 8.25516 18.7344 7.57348 18.7323 6.75785C18.7301 5.9359 18.0555 5.26406 17.2367 5.26758H17.2364Z",
    fill: "url(#paint0_linear_99_30891)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0084 15.8448C9.87156 15.837 8.13977 14.0926 8.15488 11.9639C8.17035 9.83092 9.9018 8.11143 12.027 8.11917C14.1638 8.1269 15.8956 9.87135 15.8805 12.0001C15.8654 14.1333 14.1339 15.8525 12.0084 15.8448Z",
    fill: "url(#paint1_linear_99_30891)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2366 6.32911C17.4753 6.3277 17.6712 6.52282 17.6704 6.76153C17.6697 6.99708 17.4669 7.19782 17.2338 7.1943C17.0102 7.19079 16.8098 6.99075 16.8053 6.76716C16.8007 6.53372 17.0011 6.33052 17.2366 6.32911Z",
    fill: "url(#paint2_linear_99_30891)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_99_30891",
    x1: 3.00049,
    y1: 18.4746,
    x2: 26.0005,
    y2: -9.52539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E5774D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#AE02A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1801A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_99_30891",
    x1: 8.14219,
    y1: 14.7726,
    x2: 18.0315,
    y2: 2.73453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E5774D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#AE02A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1801A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_99_30891",
    x1: 16.8038,
    y1: 7.07427,
    x2: 17.9113,
    y2: 5.72603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E5774D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#AE02A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1801A1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_99_30891"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.846df9f834d8302fdfd0470c458f0bf4.svg";
export { ForwardRef as ReactComponent };